import React from "react";
import { useTranslation } from "react-i18next";
import PopupTrigger from "../../../../common/PopupTrigger";
import Toast from "../../../../common/Toast";

const AnsweringCompleteToast = ( props ) => {

  const { t } = useTranslation();

  return <PopupTrigger onClose={ props.onHide }><Toast>{ t( 'LC_05_20.msg024' ) }</Toast></PopupTrigger>;

};

export default AnsweringCompleteToast;
